import {
  buildEnumLookup,
  blankIfNotMappedColumns,
  resolveEnumDisplayValue,
} from "../utils/enumDisplayUtils";
import { useMemo, useCallback } from "react";

export const useEnumDisplayValues = (columnsData) => {
  const defaultToBlankColumns = useMemo(
    () => blankIfNotMappedColumns(columnsData, "_type", "_subType"),
    [columnsData]
  );

  const defaultToBlankInputColumns = useMemo(
    () => blankIfNotMappedColumns(columnsData, "_inputType", "_inputSubType"),
    [columnsData]
  );

  const enumLookup = useMemo(() => buildEnumLookup(columnsData, "_options"), [
    columnsData,
  ]);

  const inputEnumLookup = useMemo(
    () => buildEnumLookup(columnsData, "_inputOptions"),
    [columnsData]
  );

  const getDisplayValue = useCallback(
    (columnName, internalValue) =>
      resolveEnumDisplayValue(
        enumLookup,
        defaultToBlankColumns,
        columnName,
        internalValue
      ),
    [enumLookup, defaultToBlankColumns]
  );

  const getInputDisplayValue = useCallback(
    (columnName, internalValue) =>
      resolveEnumDisplayValue(
        inputEnumLookup,
        defaultToBlankInputColumns,
        columnName,
        internalValue
      ),
    [inputEnumLookup, defaultToBlankInputColumns]
  );

  return {
    enumLookup,
    inputEnumLookup,
    isLoading: false,
    getDisplayValue,
    getInputDisplayValue,
  };
};
export default useEnumDisplayValues;
